export const TRANSFERS_CONTAINER_TAG_NAME = 'transfers-container';
